<template>
  <div class="game">
    <div class="game-content" v-for="(item,index) in list" :key="index">
      <div class="left">
        <img :src="item.src" />
      </div>
      <div class="right">
        <h3>{{item.name}}</h3>
        <p>{{item.brief}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Game",
  data() {
    return {
      list: [
        {
          src: require("./images/tank.png"),
          name: "超级坦克王",
          brief:
            "《超级坦克王》是一款对战类游戏，一人一发炮弹，各种炫酷的技能，远距离炮轰，靠的就是你的预判，你敢挑战吗"
        },
        {
          src: require("./images/gun.png"),
          name: "枪王射击",
          brief:
            "《枪王射击》是一款射击类游戏，重重关卡，层层危机，枪枪爆头，开启吃鸡模式，快来展现你的火力。"
        },
        {
          src: require("./images/ball.png"),
          name: "沙漠球球",
          brief:
            "《沙漠球球》是一款超休闲的游戏，在沙漠里寻找小球，快来滑动你的手指，引导小球装车。"
        },
        {
          src: require("./images/zidan.png"),
          name: "子弹行动",
          brief:
            "《子弹行动》是一款枪类射击游戏，玩家需要操作一名特工完成行动，通过有限的子弹，消灭场景下的所有敌人，快来一起体验吧。"
        }
      ]
    };
  }
};
</script>

<style scoped>
.game {
  width: 100%;
  background-color: #ffffff;
  color: #343a40;
  margin: 1.875rem 0;
}
.game-content {
  display: flex;
  width: 60%;
  margin: 1.25rem auto;
  border: 1px solid #7e8c8d;
  padding: 0.625rem 0.9375rem;
  text-align: left;
}
img {
  width: 10rem;
  height: 10rem;
}
h3 {
  margin: 1rem;
  color: #0086fb;
}
.right p {
  text-indent: 1.5rem;
  padding: 0 0.625rem;
  text-align: left;
}
@media screen and (max-width: 472px) {
  .game-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 1.25rem auto;
    border: 1px solid #7e8c8d;
    padding: 0.625rem 0.9375rem;
    text-align: center;
  }
}
@media screen and (min-width: 472px) {
  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
